export default {
  getDonor: (state) => (id) => {
    id = parseInt(id);
    if (state.donors && id) {
      return state.donors.find(p => parseInt(p.id) === id);
    }
    return null;
  },
}
